<template>
  <div class="solutions-section">
    <div class="solutions-inner">
      <div class="solutions-content">
        <div>
          <span class="p2">{{ $t("home.v2.news.title1") }}</span>
          <span class="p3">{{ $t("home.v2.news.title2") }}</span>
        </div>
        <div class="solutions-btn" @click="toNews">
          <p class="p4">{{ $t("home.v2.news.viewAll") }}</p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="solutions-img">
      <div v-for="item in listData" :key="item.id" class="solutions-item" @click="toNewItem(item.articleId)">
        <div>
          <div class="time">
            <i class="el-icon-time" />{{ dateFormatter(new Date(item.createTime), "yyyy-MM-dd hh:mm:ss") }}
          </div>
          <p class="solutions-title">{{ item.title }}</p>
          <p class="solutions-desc">{{ $t("home.v2.news.explore") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "News",
  data() {
    return {
      listData: [],
      pageParams: {
        page: 1,
        rows: 6,
        cateCode: "news|platform_notice", // 焦点图：banner、新闻：news、系统通知：system_notice，平台公告：platform_notice、个人消息：personal_notice、常见问题：question
      },
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    toNews() {
      this.$router.push({ path: "/news" });
    },
    toNewItem(articleId) {
      this.$router.push({ path: "/newsDetail", query: { id: articleId } });
    },
    getDataInfo() {
      this.$axios.post("/cms/getList", this.pageParams).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.listData = (res.data.data.rows || []).slice(0, this.pageParams.rows);
          console.log("listData", this.listData);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.solutions-section {
  padding: 100px 60px;
  background: #ffffff;
  box-sizing: border-box;
}
.solutions-inner {
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
  }
}
.solutions-content {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .p2 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #333333;
  }
  .p3 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #E05807;
    line-height: 50px;
  }
  .p4 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
  }
  .solutions-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #333333;
    p {
      padding-bottom: 12px;
    }
    i {
      font-size: 24px;
      color: #333333;
      margin-left: 8px;
    }
  }
}

.solutions-img {
  gap: 20px;
  display: grid;
  padding-top: 48px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  .solutions-item {
    padding: 20px;
    cursor: pointer;
    border-radius: 12px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    .time {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      i {
        color: #8f959e;
        margin-right: 8px;
      }
    }
    .solutions-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 32px;
      color: #333333;
      margin-top: 12px;
      margin-bottom: 45px;
      line-height: 1.5;
      min-height: 96px;
    }
    .solutions-desc {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #E05807;
      text-align: end;
    }
  }
}
</style>
